<template>
    <div class="page">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="weui-icon-success weui-icon_msg"></i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">支付成功</h2>
                <p class="weui-msg__desc">
                    我们会尽快安排小伙伴帮您送件上门，请保持联系电话畅通，感谢您对校圆通的支持。
                </p>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <a href="javascript:;" class="weui-btn weui-btn_primary" @click="back">回到我要取件</a>
                </p>
            </div>
            <div class="weui-msg__extra-area">
                <div class="weui-footer">
                    <p class="weui-footer__links">
                        <a href="javascript:void(0);" class="weui-footer__link">底部链接文本</a>
                    </p>
                    <p class="weui-footer__text">Copyright &copy; 2008-2016 weui.io</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      encodeToken: ""
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
  },
  methods: {
    back() {
      this.$router.push("/expressTotakeList/ing/" + this.encodeToken);
    }
  }
};
</script>

<style scoped>
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/PaySuccess.vue